import { Stack } from '@mui/material'
import Button from '@mui/material/Button'
import SaveIcon from '@mui/icons-material/SaveAltOutlined'
import Editor from '@monaco-editor/react'
import { isMobile } from 'react-device-detect'
import axios from 'axios'
import { useParams } from 'react-router-dom'
import { useRef } from 'react'
import { useAuth } from '../../../context/useAuth'

interface Props {
  visible: boolean
  simulation: any
  setSimulation: any
}

const formatJSON = (json: any) => {
  try {
    const res = JSON.parse(json)
    return JSON.stringify(res, null, 2)
  } catch {
    const errorJson = {
      error: `${json}`,
    }
    return JSON.stringify(errorJson, null, 2)
  }
}

export default function Raw({ visible, simulation, setSimulation }: Props) {
  const { name } = useParams()
  const { csrf } = useAuth()
  const editorRef = useRef<any>(null)

  const handleSave = async () => {
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_API}/${name}/update_raw`,
        JSON.stringify(editorRef?.current?.getValue()),
        {
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': csrf,
          },
          withCredentials: true,
        }
      )
      setSimulation(res.data)
    } catch (err) {
      console.log('err:', err)
    }
  }

  const handleEditorDidMount = (editor: any, monaco: any) => {
    editorRef.current = editor
  }

  return (
    <Stack sx={{ display: visible ? 'flex' : 'none' }}>
      <Button
        sx={{ mb: 3, width: 150, ml: 2, fontSize: 11 }}
        startIcon={<SaveIcon />}
        variant='outlined'
        size='small'
        onClick={handleSave}
      >
        Save changes
      </Button>
      <Editor
        options={
          isMobile
            ? {
                minimap: { enabled: false },
                lineNumbers: 'off',
                glyphMargin: false,
                folding: false,
              }
            : {}
        }
        height='70vh'
        language='json'
        theme='vs-light'
        value={formatJSON(JSON.stringify(simulation))}
        onMount={handleEditorDidMount}
      />
    </Stack>
  )
}
